export default __webpack_public_path__ + "static/media/royal-society-event.7a6b1ba5.png";